import ConfigureComputeServer from '../../pages/ConfigureComputeServer'
import CreateFloatingClientLicenseFile from '../../pages/CreateFloatingClientLicenseFile'
import DockerComputeServer from '../../pages/DockerComputeServer'
import DockerStartComputeServer from '../../pages/DockerStartComputeServer'
import InstallRemoteServices from '../../pages/InstallRemoteServices'
import { createDescriptor, PageDescriptor } from '../../pages/types'
import RetrieveLocalLicense from '../../pages/RetrieveLocalLicense'
import StartComputeServer from '../../pages/StartComputeServer'
import { ServerBrick } from './ServerBrick'
import { ReactNode } from 'react'

export class ComputeServerBrick extends ServerBrick {
    private container: boolean
    private orchestrated: boolean

    constructor(license: 'cs' | 'tsclient' | 'wlscs', readonly os: string, container: boolean, isOrchestrated: boolean, readonly hasClusterManager: boolean) {
        super(license)
        this.container = container
        this.orchestrated = isOrchestrated
    }

    public key(): string { 
        return 'cs'
    }

    public isContainer(): boolean {
        return this.container
    }

    public isOrchestrated(): boolean {
        return this.orchestrated
    }

    get icon(): string {
        return 'solver'
    }

    get title(): string {
        return 'Compute Server'
    }


    get sortIndex(): number {
        return 2
    }

    *getPages(): Generator<PageDescriptor> {
        const { os, license, container: isContainer, hasClusterManager: clusterManager } = this
        if(this.container) {
            yield createDescriptor(DockerComputeServer, {})
            yield createDescriptor(ConfigureComputeServer, { isContainer, clusterManager })
            if(this.license == 'tsclient') {
                yield createDescriptor(CreateFloatingClientLicenseFile, { os, isContainer })
            }
            if(['wlscs', 'tsclient'].includes(this.license??'') && isContainer && !this.orchestrated) {
                yield createDescriptor(DockerStartComputeServer, { license: license! })
            }
        } else {
            yield createDescriptor(InstallRemoteServices, { os })
            if(this.license == 'cs') {
                yield createDescriptor(RetrieveLocalLicense, {})
            }
            if(this.license == 'tsclient') {
                yield createDescriptor(CreateFloatingClientLicenseFile, { os, isContainer })
            }
            yield createDescriptor(ConfigureComputeServer, { isContainer, clusterManager })
            if(!this.hasClusterManager) {
                yield createDescriptor(StartComputeServer, { })
            }            
        }
    }

    public describe(): ReactNode
    {
        const licenseLines : Record<string, ReactNode> = {
            "tsclient": <>It requests a <b>token</b> from your Token Server.</>,
            "wlscs": <>It requests a <b>token</b> from the Web License Service.</>,
            "cs": <>It contains your <b>Compute Server</b> license which is bound to the (virtual) machine hosting the Compute Server.</>
        }        
        return <p>The <b>Compute Server</b> runs in your environment {this.container ? "inside a container" : "on a (virtual) machine"}. {licenseLines[this.license!]} {this.hasClusterManager && <>It is not accessed by your application directly, but through the Cluster Manager.</>} </p>        
    }
}
